import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { Backdrop, Rating, SwipeableDrawer, styled } from '@mui/material';
import cn from 'classnames';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CustomButton, Icon } from '../../components';
import { Drawer } from '../../components/Drawer';

import styles from './Review.module.sass';
import ReviewForm from './ReviewForm/ReviewForm';
import ReviewList from './ReviewList';
import { useReviews } from './useReviews';

// Кастомный стиль
const CssSwipableDrawer = styled(SwipeableDrawer)({
  '& .MuiDrawer-paper': {
    top: '114px',
  },
});

// Стилизованный компонент для изменения фона
const StyledBackdrop = styled(Backdrop)`
  background-color: rgba(0, 0, 0, 0);
  z-index: -1;
  top: 114px;
`;

interface IReview {
  onOpen: () => void;
  showAllReviews: boolean;
  onClose: () => void;
}

const Review: FC<IReview> = ({ onOpen, showAllReviews, onClose }) => {
  const {
    review,
    isReviewCount,
    checkUserId,
    handleShowMore,
    isAllUploaded,
    reviewCount,
    stars_avg,
    mobileScreen,
    isOpenModalForm,
    handleShowModalForm,
  } = useReviews(showAllReviews);
  return (
    <div
      role="presentation"
      className={cn(styles.drawer, {
        [styles.showAllReviews]: showAllReviews,
      })}
    >
      <div className={styles.header}>
        <div className={styles.topLeft}>
          {mobileScreen && showAllReviews && (
            <ArrowBackIosNewRoundedIcon onClick={onClose} />
          )}
          <h2 className={styles.title} id="myBlock">
            {!showAllReviews && mobileScreen
              ? `Отзывы: ${reviewCount}`
              : `Отзывы (${reviewCount})`}
          </h2>
          {!showAllReviews && (
            <div className={styles.stars}>
              <Rating
                size="large"
                readOnly
                defaultValue={0}
                value={Math.floor(Number(stars_avg))}
              />
            </div>
          )}
        </div>
        {mobileScreen && !showAllReviews && (
          <div className={styles.more} onClick={onOpen}>
            См. все
          </div>
        )}
      </div>

      <ReviewList review={review} />
      {/*      {isLoading && <SkeletonLoader />}*/}

      {!mobileScreen && isReviewCount ? (
        <>
          {isAllUploaded ? (
            <></>
          ) : (
            <button
              onClick={handleShowMore}
              className={styles.btnMore}
              type="button"
            >
              Показать больше отзывов
            </button>
          )}
        </>
      ) : (
        <>
          {!checkUserId && (
            <button
              className={styles.btnMore}
              type="button"
              onClick={handleShowModalForm}
            >
              Написать отзыв
            </button>
          )}
        </>
      )}

      {!checkUserId && (
        <>
          {mobileScreen ? (
            <Drawer visible={isOpenModalForm} position="bottom">
              <ReviewForm handleShowModalForm={handleShowModalForm} />
            </Drawer>
          ) : (
            <ReviewForm handleShowModalForm={handleShowModalForm} />
          )}
        </>
      )}
    </div>
  );
};

export default Review;
